import React from 'react';
import { Stack } from '@mui/material';
import { Images } from '@travelity/form';

export interface ProductImagesFormProps {
    preview?: boolean;
}

const ProductImagesForm: React.FC<ProductImagesFormProps> = ({ preview }) => {
    return (
        <Stack spacing={2} sx={{ width: { xs: '100%', sm: '453px' } }}>
            <Images name="images" readOnly={preview} />
        </Stack>
    );
};

export default React.memo(ProductImagesForm);
